(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 4705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m18 6-1.43 1.393L24.15 15H4v2h20.15l-7.58 7.573L18 26l10-10L18 6z"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);

/***/ }),

/***/ 4593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Zm-2.2 2L16 14.78 6.2 8ZM4 24V8.91l11.43 7.91a1 1 0 0 0 1.14 0L28 8.91V24Z"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEmail);

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2303);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7045);
/* harmony import */ var _FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3082);
/* harmony import */ var react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2__);





var FadeIn = function(props) {
    var classNamesInit = (_FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["fade-in-container"]);
    if (props.classNames) classNamesInit += " ".concat(props.classNames);
    if (props.noTop) classNamesInit += " ".concat((_FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["no-top"]));
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(classNamesInit), 2), classNames = ref[0], setClassNames = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2___default()), {
        onChange: function(isVisible) {
            if (classNames.indexOf("active") === -1 && isVisible) setClassNames("".concat(classNames, " ").concat((_FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3___default().active)));
        },
        partialVisibility: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classNames,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_FadeIn_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["fade-in-content"]),
                children: props.children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FadeIn);


/***/ }),

/***/ 6578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Input_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2110);
/* harmony import */ var _Input_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Input_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Input = function(props) {
    var classNames = "input-container";
    if (props.classNames) classNames += " ".concat(props.classNames);
    if (props.disabled) classNames += " ".concat((_Input_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled));
    var handleOnChange = function(e) {
        props.onChange && props.onChange(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: classNames,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: props.label
            }),
            props.isTextarea ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                name: props.name ? props.name : undefined,
                onChange: handleOnChange,
                disabled: props.disabled ? true : false,
                className: (_Input_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["text-input"]),
                value: props.value,
                placeholder: props.placeholder
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                autoComplete: props.autoComplete,
                name: props.name ? props.name : undefined,
                onChange: handleOnChange,
                disabled: props.disabled ? true : false,
                className: (_Input_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["text-input"]),
                type: props.kind ? props.kind : "text",
                value: props.value,
                placeholder: props.placeholder
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 5255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Components_PageNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(3493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./Components/assets/list--dropdown.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgListDropdown = function SvgListDropdown(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1H1v5h4.5v9H15V3h-2V1ZM2 5V2h10v1H5.5v2H2Zm12 9H6.5V4H14v10ZM8.5 5.5h-1v1h1v-1Zm1 0H13v1H9.5v-1Zm-1 3h-1v1h1v-1Zm1 0H13v1H9.5v-1Zm-1 3h-1v1h1v-1Zm1 0H13v1H9.5v-1Z",
    fill: "#000"
  })));
};
/* harmony default export */ var list_dropdown = (SvgListDropdown);
// EXTERNAL MODULE: ./Components/Button.module.scss
var Button_module = __webpack_require__(7547);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./Components/PageNav.tsx






/* function convertRemToPixels(rem: number): number {
    return rem * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
} */ var leftOffset = 32;
var overrideOffset = 150;
var mobileBreak = 1024;
var maxWidth = 1392;
var PageNav = function(param) {
    var setActiveNo = param.setActiveNo, activeNo = param.activeNo, pageSections = param.pageSections, elRefs = param.elRefs, /*newsHeaderRef,*/ activationRef = param.activationRef;
    var scrollToAnchor = function scrollToAnchor(aId) {
        pageSections.forEach(function(pageSection, i) {
            if (pageSection.anchorId === aId) {
                var offset = window.innerHeight - window.innerHeight / 1.25;
                var y = Math.floor(elRefs[i].current.getBoundingClientRect().top + window.pageYOffset - offset);
                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            }
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), prevWidth = ref[0], setPrevWidth = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), scrollProgress = ref1[0], setScrollProgress = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), navClassNames = ref2[0], setNavClassNames = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), mobileNavClassNames = ref3[0], setMobileNavClassNames = ref3[1];
    var mobileNavRef = react.useRef(null);
    var sectionNavRef = react.useRef(null);
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), navTopValue = ref4[0], setNavTopValue = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), navLeftValue = ref5[0], setNavLeftValue = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState({}), 2), navStyles = ref6[0], setNavStyles = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), breaks = ref7[0], setBreaks = ref7[1];
    var handleScroll = throttle_default()(function() {
        var overrideElement = elRefs[elRefs.length - 2].current;
        var lastElement = elRefs[elRefs.length - 1].current;
        var firstElement = elRefs[0].current;
        if (activationRef && activationRef.current && /*newsHeaderRef.current &&*/ mobileNavRef.current && sectionNavRef.current && overrideElement && lastElement && firstElement) {
            var ref;
            var classNameStr = "";
            var topElementOffset = prevWidth > mobileBreak ? activationRef.current.offsetHeight - 160 : activationRef.current.offsetHeight;
            var currentScrollPos = window.pageYOffset;
            if (lastElement.getBoundingClientRect().top - overrideOffset <= 0) {
                setNavTopValue(lastElement.offsetTop + 58);
                classNameStr += " override";
            } else {
                if (currentScrollPos >= topElementOffset) classNameStr += " fixed";
            }
            setNavClassNames(classNameStr);
            if (currentScrollPos >= activationRef.current.offsetHeight - Math.ceil(((ref = mobileNavRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) / 2)) {
                setMobileNavClassNames(" fixed");
            } else {
                setMobileNavClassNames("");
            }
            var activeItems = breaks.filter(function(val) {
                return val <= currentScrollPos - topElementOffset + window.innerHeight / 1.25;
            });
            var activeNo = activeItems.length;
            setActiveNo(activeNo - 1);
            setScrollProgress(activeNo / breaks.length * 100);
            setBreaks(elRefs.map(function(elRef) {
                if (elRef.current) {
                    return elRef.current.offsetTop;
                }
                return -1;
            }));
        }
    }, 250);
    var handleResize = throttle_default()(function() {
        var width = window.innerWidth;
        var calcOffset = (width - maxWidth) / 2;
        var offset = calcOffset > leftOffset ? calcOffset : leftOffset;
        setNavLeftValue(width >= maxWidth ? offset : leftOffset);
        setPrevWidth(width);
    }, 250);
    react.useEffect(function() {
        var newNavStyles = {
            top: "",
            left: ""
        };
        if (navTopValue) {
            newNavStyles.top = "".concat(navTopValue, "px");
        }
        if (navLeftValue) {
            newNavStyles.left = "".concat(navLeftValue, "px");
        }
        if (navClassNames.indexOf("override") === -1) {
            delete newNavStyles.top;
        }
        setNavStyles(newNavStyles);
    }, [
        navTopValue,
        navLeftValue,
        navClassNames
    ]);
    var handleOnChange = function(e) {
        scrollToAnchor(e.target.value);
    };
    var handleOnClick = function(aId) {
        scrollToAnchor(aId);
    };
    react.useEffect(function() {
        handleScroll();
        handleResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(function() {
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, [
        handleResize,
        handleScroll
    ]);
    var className = "".concat((Button_module_default()).button, " ").concat((Button_module_default()).white);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "page-section-nav ".concat(navClassNames),
                style: navStyles,
                ref: sectionNavRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "page-section-nav-list",
                    children: pageSections.map(function(section, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "Scroll to ".concat(section.title, " section"),
                                    type: "button",
                                    className: i === activeNo ? "active" : "",
                                    onClick: function() {
                                        return handleOnClick(section.anchorId);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: String(i).padStart(2, "0")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "title",
                                    children: section.title
                                })
                            ]
                        }, "section-nav-".concat(i));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "select-container page-section-nav-mobile".concat(mobileNavClassNames),
                ref: mobileNavRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list_dropdown, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        name: "page-section-nav-mobile-menu",
                        className: "select",
                        title: "Mobile navigation menu",
                        onChange: handleOnChange,
                        value: pageSections[activeNo] ? pageSections[activeNo].anchorId : "",
                        children: pageSections.map(function(section, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: section.anchorId,
                                children: "".concat(String(i).padStart(2, "0"), ": ").concat(section.title)
                            }, "section-nav-mobile-".concat(i));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "page-section-nav-mobile-progress-bar",
                        style: {
                            width: "".concat(scrollProgress, "%")
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Components_PageNav = (PageNav);


/***/ }),

/***/ 831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ getCanonicalArticleUrl; },
/* harmony export */   "i$": function() { return /* binding */ stringCutter; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

var publicRuntimeConfig = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])().publicRuntimeConfig;
function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
function stringCutter(content) {
    return content.length > 180 ? "".concat(content.slice(0, 177), "...") : content;
}
function getCanonicalArticleUrl(title, aid, type, generateCanonical) {
    var canonicalUrl = generateCanonical ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_SITE_URL, "/").concat(type) : "/".concat(type);
    if (title) {
        canonicalUrl += "/".concat(title.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, ""));
    }
    canonicalUrl += "/aid/".concat(aid);
    canonicalUrl = canonicalUrl.toLowerCase();
    return canonicalUrl;
}


/***/ }),

/***/ 2303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./Components/PageNav.tsx + 1 modules
var PageNav = __webpack_require__(5255);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./Components/Button.tsx
var Button = __webpack_require__(755);
// EXTERNAL MODULE: ./Components/Splitter.tsx
var Splitter = __webpack_require__(8025);
// EXTERNAL MODULE: ./Components/Typer.tsx
var Typer = __webpack_require__(4100);
// EXTERNAL MODULE: ./Components/FadeIn.tsx
var FadeIn = __webpack_require__(5187);
;// CONCATENATED MODULE: ./Components/assets/performance-circle.svg
var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPerformanceCircle = function SvgPerformanceCircle(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 359 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 179.5,
    cy: 179.5,
    r: 179.5,
    fill: "url(#performance-circle_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "performance-circle_svg__a",
    x1: 179.5,
    y1: 0,
    x2: 179.5,
    y2: 359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#7D48ED"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#4205C3"
  })))));
};
/* harmony default export */ var performance_circle = (SvgPerformanceCircle);
// EXTERNAL MODULE: ./Components/assets/arrow--right.svg
var arrow_right = __webpack_require__(4705);
// EXTERNAL MODULE: ./PageSections/HomeSections/Performance.module.scss
var Performance_module = __webpack_require__(5267);
var Performance_module_default = /*#__PURE__*/__webpack_require__.n(Performance_module);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(3082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Performance.tsx












function nFormatter(num, digits) {
    if (num) {
        var lookup = [
            {
                value: 1,
                symbol: ""
            },
            {
                value: 1e3,
                symbol: "k"
            },
            {
                value: 1e6,
                symbol: "M"
            },
            {
                value: 1e9,
                symbol: "G"
            },
            {
                value: 1e12,
                symbol: "T"
            },
            {
                value: 1e15,
                symbol: "P"
            },
            {
                value: 1e18,
                symbol: "E"
            }
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var item = lookup.slice().reverse().find(function(item) {
            return num >= item.value;
        });
        return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }
    return "\u2014";
}
var epoch = 1648758747716;
var today = new Date().getTime();
var hoursDifference = Math.ceil((today - epoch) / 3600000);
var metric1Base = 30000;
var metric2Base = Math.ceil(282157 + 2297 / 24 * hoursDifference);
var metric3Base = Math.ceil(730 + 7 / 24 * hoursDifference);
var metric4Base = Math.ceil(7 * 30 * 2);
var frameTime = 30;
var HomePerformance = /*#__PURE__*/ react.forwardRef(function HomePerformance(props, ref) {
    var intervalId1 = react.useRef(null);
    var hasRunOnce = react.useRef(false);
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), activated = _$ref[0], setActivated = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isVisible = _$ref1[0], setIsVisible = _$ref1[1];
    var _$ref2 = (0,_sliced_to_array/* default */.Z)(react.useState({
        completeCounter: 0,
        metrics: [
            {
                frameTime: Math.floor(metric1Base / frameTime),
                base: metric1Base,
                current: 0
            },
            {
                frameTime: Math.floor(metric2Base / frameTime),
                base: metric2Base,
                current: 0
            },
            {
                frameTime: Math.floor(metric3Base / frameTime),
                base: metric3Base,
                current: 0
            },
            {
                frameTime: Math.floor(metric4Base / frameTime),
                base: metric4Base,
                current: 0
            }, 
        ]
    }), 2), metricsObj = _$ref2[0], setMetricsObj = _$ref2[1];
    var addMetrics = react.useCallback(function() {
        var newMetricsObj = (0,_object_spread/* default */.Z)({}, metricsObj);
        newMetricsObj.metrics = metricsObj.metrics.map(function(metric) {
            if (metric.current < metric.base) {
                metric.current += metric.frameTime;
            } else {
                newMetricsObj.completeCounter += 1;
            }
            return metric;
        });
        if (newMetricsObj.completeCounter >= newMetricsObj.metrics.length) hasRunOnce.current = true;
        setMetricsObj(newMetricsObj);
    }, [
        metricsObj
    ]);
    react.useEffect(function() {
        if (isVisible && !activated) setActivated(true);
        if (activated && !hasRunOnce.current) {
            var timeoutSession1 = setTimeout(function() {
                addMetrics();
            }, frameTime);
            intervalId1.current = timeoutSession1;
        }
    }, [
        addMetrics,
        metricsObj,
        isVisible,
        activated
    ]);
    react.useEffect(function() {
        return function() {
            if (intervalId1.current) clearTimeout(intervalId1.current);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "performance",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Splitter/* default */.Z, {
                    vizTrigger: true,
                    isThick: true,
                    text: String(props.sectionNo).padStart(2, "0")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container padded-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "_2-col-titled",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "h2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typer/* default */.Z, {
                                    vizTrigger: true,
                                    text: "Metrics"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "_2-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "big-text",
                                                        children: props.data && props.data.MetricsParagraph1 ? props.data.MetricsParagraph1 : "Our highly-available and reliable automated solutions are designed to help satellite operators focus on their core missions, without having to worry about the safety of their fleet."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "big-text",
                                                        children: props.data && props.data.MetricsParagraph2 ? props.data.MetricsParagraph2 : "We accomplish this by removing delays and errors from the critical response path. This saves time and money for our customers by reducing the response time by more than 95%, optimizing the avoidance maneuvers with the mission critical timelines, minimizing the need for unnecessary maneuvers, and improving the mission output."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Splitter/* default */.Z, {
                                            vizTrigger: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((Performance_module_default())["performance-container"], " _2-col ").concat(activated ? " ".concat((Performance_module_default()).active) : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Performance_module_default())["metrics-column"],
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Performance_module_default())["metric-number"],
                                                                        children: nFormatter(metricsObj.metrics[0].current, 0)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Objects tracked"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Performance_module_default())["metric-number"],
                                                                        children: nFormatter(metricsObj.metrics[1].current, 0)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Warnings delivered"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Performance_module_default())["metric-number"],
                                                                        children: nFormatter(metricsObj.metrics[2].current, 0)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Maneuvers generated"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Performance_module_default())["metrics-bubble-column"],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Performance_module_default())["metric-bubble-container"],
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(performance_circle, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (Performance_module_default())["metric-container"],
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                                                                            onChange: function(isVisible) {
                                                                                if (!hasRunOnce.current && isVisible) setIsVisible(true);
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (Performance_module_default())["metric-number"],
                                                                                children: nFormatter(metricsObj.metrics[3].current, 2)
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            children: [
                                                                                "Operator hours",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                                "saved per month"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Splitter/* default */.Z, {
                                            vizTrigger: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "_2-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col mobile-no-padding-bottom",
                                                    children: props.data && props.data.PerformanceCTATitle && props.data.PerformanceCTAUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        renderIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {}),
                                                        isLink: true,
                                                        href: props.data.PerformanceCTAUrl,
                                                        text: props.data.PerformanceCTATitle
                                                    }) : null
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col empty"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var Performance = (HomePerformance);

// EXTERNAL MODULE: ./PageSections/HomeSections/Quotes.module.scss
var Quotes_module = __webpack_require__(1206);
var Quotes_module_default = /*#__PURE__*/__webpack_require__.n(Quotes_module);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Quotes.tsx







var HomeQuotes = /*#__PURE__*/ react.forwardRef(function HomeQuotes(props, ref) {
    var intervalId1 = react.useRef(null);
    var intervalId2 = react.useRef(null);
    var intervalId3 = react.useRef(null);
    var intervalId4 = react.useRef(null);
    var intervalId5 = react.useRef(null);
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), part = _$ref[0], setPart = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), partIdx = _$ref1[0], setPartIdx = _$ref1[1];
    var _$ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), text = _$ref2[0], setText = _$ref2[1];
    var _$ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isDeleting = _$ref3[0], setIsDeleting = _$ref3[1];
    var hasRunOnce = react.useRef(false);
    var _$ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), hideTitle = _$ref4[0], setHideTitle = _$ref4[1];
    var quoteGhosts = react.useRef(props.data ? props.data.map(function(quoteObj, i) {
        return quoteObj.Quote && quoteObj.Name && quoteObj.JobTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Quotes_module_default()).ghost,
            children: quoteObj.Quote
        }, "quote-ghost-".concat(i)) : null;
    }) : []);
    var nameGhosts = react.useRef(props.data ? props.data.map(function(quoteObj, i) {
        return quoteObj.Quote && quoteObj.Name && quoteObj.JobTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Quotes_module_default()).ghost,
            children: quoteObj.Name
        }, "name-ghost-".concat(i)) : null;
    }) : []);
    var titleGhosts = react.useRef(props.data ? props.data.map(function(quoteObj, i) {
        return quoteObj.Quote && quoteObj.Name && quoteObj.JobTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Quotes_module_default()).ghost,
            children: quoteObj.JobTitle
        }, "title-ghost-".concat(i)) : null;
    }) : []);
    var typeQuote = react.useCallback(function() {
        // Get substring with 1 characater added
        var newPartIdx = partIdx + 1;
        if (props.data && props.data[part]) {
            var text = props.data[part].Quote.substring(0, newPartIdx);
            setText(text);
            setPartIdx(newPartIdx);
            if (text === props.data[part].Quote) {
                setHideTitle(false);
                var timeoutSession1 = setTimeout(function() {
                    setIsDeleting(true);
                }, 15000);
                intervalId1.current = timeoutSession1;
            }
        }
    }, [
        partIdx,
        part
    ]);
    var deleteQuote = react.useCallback(function() {
        // Get substring with 1 characater deleted
        if (partIdx !== 0) {
            setText("");
            setPartIdx(0);
        }
    }, [
        partIdx
    ]);
    react.useEffect(function() {
        if (props.data && props.data[part]) {
            if (!hasRunOnce.current) {
                var timeoutSession2 = setTimeout(function() {
                    hasRunOnce.current = true;
                    typeQuote();
                }, 500);
                intervalId2.current = timeoutSession2;
            }
            if (text.length !== props.data[part].Quote.length && !isDeleting && hasRunOnce.current) {
                var timeoutSession3 = setTimeout(function() {
                    typeQuote();
                }, 17);
                intervalId3.current = timeoutSession3;
            } else if (isDeleting && text.length) {
                var timeoutSession4 = setTimeout(function() {
                    deleteQuote();
                }, 2000);
                intervalId4.current = timeoutSession4;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        partIdx,
        typeQuote,
        deleteQuote,
        isDeleting,
        part
    ]);
    react.useEffect(function() {
        if (!text.length && isDeleting) {
            setHideTitle(true);
            var timeoutSession5 = setTimeout(function() {
                var nextPart = part + 1;
                if (nextPart > props.data.length - 1) nextPart = 0;
                setIsDeleting(false);
                setPart(nextPart);
            }, 3000);
            intervalId5.current = timeoutSession5;
        }
    }, [
        text,
        isDeleting,
        intervalId5,
        part
    ]);
    react.useEffect(function() {
        return function() {
            if (intervalId1.current) clearTimeout(intervalId1.current);
            if (intervalId2.current) clearTimeout(intervalId2.current);
            if (intervalId3.current) clearTimeout(intervalId3.current);
            if (intervalId4.current) clearTimeout(intervalId4.current);
            if (intervalId5.current) clearTimeout(intervalId5.current);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "quotes",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Splitter/* default */.Z, {
                    vizTrigger: true,
                    isThick: true,
                    text: String(props.sectionNo).padStart(2, "0")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container padded-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "_2-col-titled",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "h2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typer/* default */.Z, {
                                    vizTrigger: true,
                                    text: "Quotes"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: props.data && props.data[part] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Quotes_module_default())["quote-container"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Quotes_module_default())["quote-content"], " big-text"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Quotes_module_default()).quote,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                                                                className: "".concat((Quotes_module_default())["q-container"], " ").concat(isDeleting && partIdx ? " ".concat((Quotes_module_default()).deleting) : ""),
                                                                children: text
                                                            }, String(partIdx)),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((Quotes_module_default())["quote-cursor"]).concat(!isDeleting || partIdx === 0 ? " ".concat((Quotes_module_default()).active) : "")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Quotes_module_default()).ghosts,
                                                        children: quoteGhosts.current
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Quotes_module_default())["quote-name-title"]).concat(!hideTitle && !isDeleting ? " ".concat((Quotes_module_default()).active) : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((Quotes_module_default())["content-ghost-container"], " ").concat((Quotes_module_default())["name-container"]),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Quotes_module_default())["quote-name"],
                                                                children: [
                                                                    "\u2014",
                                                                    props.data[part].Name,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Quotes_module_default())["quote-block"]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Quotes_module_default()).ghosts,
                                                                children: nameGhosts.current
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Quotes_module_default())["content-ghost-container"],
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Quotes_module_default())["quote-title"],
                                                                children: [
                                                                    props.data[part].JobTitle,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (Quotes_module_default())["quote-block"]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Quotes_module_default()).ghosts,
                                                                children: titleGhosts.current
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }) : null
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var Quotes = (HomeQuotes);

// EXTERNAL MODULE: ./PageSections/HomeSections/Products.module.scss
var Products_module = __webpack_require__(1123);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./strapi/media.ts
var media = __webpack_require__(2145);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Products.tsx











var HomeProducts = /*#__PURE__*/ react.forwardRef(function HomeProducts(props, ref) {
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isHovering = _$ref[0], setIsHovering = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(props.data && props.data.length ? props.data.map(function() {
        return /*#__PURE__*/ react.createRef();
    }) : []), 1), elRefs = _$ref1[0];
    var _$ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), playState = _$ref2[0], setPlayState = _$ref2[1];
    var videoEndCallback = function() {
        var val = 0;
        if (!isHovering) {
            val = playState + 1;
        }
        setPlayState(val);
    };
    var handleMouseLeave = function(i) {
        setIsHovering(false);
        elRefs.forEach(function(elRef, index) {
            var _$ref;
            var videoEl = (_$ref = elRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getElementsByTagName("video");
            if (videoEl && i === index) {
                videoEl[0].loop = false;
            }
        });
    };
    var handleMouseEnter = function(i) {
        setIsHovering(true);
        elRefs.forEach(function(elRef, index) {
            var _$ref;
            var videoEl = (_$ref = elRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getElementsByTagName("video");
            if (videoEl) {
                if (i === index) {
                    videoEl[0].loop = true;
                    if (i !== playState) {
                        videoEl[0].pause();
                        videoEl[0].currentTime = 0;
                        setPlayState(index);
                    }
                } else {
                    videoEl[0].pause();
                    videoEl[0].currentTime = 0;
                }
            }
        });
    };
    react.useEffect(function() {
        if (elRefs.length - 1 < playState) {
            setPlayState(0);
        } else {
            var _$ref;
            var videoEl = (_$ref = elRefs[playState].current) === null || _$ref === void 0 ? void 0 : _$ref.getElementsByTagName("video");
            if (videoEl) {
                videoEl[0].play();
            }
        }
    }, [
        playState,
        elRefs
    ]);
    var listItems = props.data && props.data.length ? props.data.map(function(product, index) {
        var videoSrc = product.Video ? product.Video.data ? (0,media/* getStrapiMedia */.$)(product.Video) : "" : "";
        var thumbnailSrc = product.Thumbnail ? product.Thumbnail.data ? (0,media/* getStrapiMedia */.$)(product.Thumbnail) : "" : "";
        if (thumbnailSrc && thumbnailSrc && product.Link && product.Caption && product.Content) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: product.Link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Products_module_default())["story-content"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((Products_module_default())["video-container"], " ").concat(playState === index ? " ".concat((Products_module_default()).active) : ""),
                                ref: elRefs[index],
                                onTouchStart: function() {
                                    return handleMouseEnter(index);
                                },
                                onTouchEnd: function() {
                                    return handleMouseLeave(index);
                                },
                                onMouseEnter: function() {
                                    return handleMouseEnter(index);
                                },
                                onMouseLeave: function() {
                                    return handleMouseLeave(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Products_module_default())["video-thumbnail"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            width: 900,
                                            height: 616,
                                            src: thumbnailSrc,
                                            alt: product.Thumbnail.data.attributes.caption ? product.Thumbnail.data.attributes.caption : "Thumbnail for video"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                        muted: true,
                                        controls: false,
                                        playsInline: true,
                                        onEnded: function() {
                                            return videoEndCallback();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                src: videoSrc,
                                                type: "video/mp4"
                                            }),
                                            "Your browser does not support the video tag."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Products_module_default()).description,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: product.Caption
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: product.Content
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pseudo-icon-button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, "solution-".concat(index));
        }
    }) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "products",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Splitter/* default */.Z, {
                    heroMargin: true,
                    vizTrigger: true,
                    isThick: true,
                    text: String(props.sectionNo).padStart(2, "0")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container padded-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "_2-col-titled",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "h2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typer/* default */.Z, {
                                    vizTrigger: true,
                                    text: "Products"
                                })
                            })
                        }),
                        listItems.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "".concat((Products_module_default())["solutions-list"]).concat(listItems.length % 2 !== 0 ? " ".concat((Products_module_default())["solutions-list-3col"]) : ""),
                                        children: listItems
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col empty"
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var Products = (HomeProducts);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(3493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Components/GlobeAnimationWrapper.tsx

var GlobeAnimationWrapper = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3737), __webpack_require__.e(1092), __webpack_require__.e(6983), __webpack_require__.e(8765)]).then(__webpack_require__.bind(__webpack_require__, 8765));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8765)
            ];
        }
    },
    ssr: false
});
/* harmony default export */ var Components_GlobeAnimationWrapper = (GlobeAnimationWrapper);

// EXTERNAL MODULE: ./PageSections/HomeSections/Hero.module.scss
var Hero_module = __webpack_require__(6492);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Hero.tsx









var SHIELD_SIZE = 0.2;
var HomeHero = /*#__PURE__*/ react.forwardRef(function HomeHero(props, ref) {
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), hasHovered = _$ref[0], setHasHovered = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), width = _$ref1[0], setWidth = _$ref1[1];
    var _$ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), shieldBufferLeftRight = _$ref2[0], setShieldBufferLeftRight = _$ref2[1];
    var _$ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), shieldBufferTopBottom = _$ref3[0], setShieldBufferTopBottom = _$ref3[1];
    //const [scrollAnimLeftPos, setScrollAnimLeftPos] = useState(0);
    var sectionRef = react.useRef(null);
    var _$ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), show3d = _$ref4[0], setShow3d = _$ref4[1];
    var handleMouseEnter = throttle_default()(function() {
        setHasHovered(true);
    }, 300);
    react.useEffect(function() {
        var handleResize = throttle_default()(function() {
            setShow3d(true);
            if (sectionRef !== null && sectionRef.current !== null) {
                var squaredResolutionValue = 0;
                if (sectionRef.current.offsetWidth > sectionRef.current.offsetHeight) {
                    squaredResolutionValue = sectionRef.current.offsetHeight;
                } else {
                    squaredResolutionValue = sectionRef.current.offsetWidth;
                }
                var shieldBufferTopBottom = Math.ceil(squaredResolutionValue * SHIELD_SIZE);
                setWidth(squaredResolutionValue);
                setShieldBufferLeftRight(sectionRef.current.offsetHeight - shieldBufferTopBottom * 2);
                setShieldBufferTopBottom(shieldBufferTopBottom);
            //48 is half of 96px (width of the svg)
            //setScrollAnimLeftPos((squaredResolutionValue / 2) - 48);
            }
        }, 300);
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: ref,
        className: "layer-1-bg",
        id: "hero",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "content-container ".concat((Hero_module_default())["home-hero"]),
            ref: sectionRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "_x-col-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "_2-col hero",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Hero_module_default())["hero-content-container"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: "hero-slogan",
                                            children: [
                                                "Making ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Spaceflight ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tm",
                                                    children: "Safer"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "big-text description",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Hero_module_default())["hero-text-background"],
                                                        children: props.HeroParagraph ? props.HeroParagraph : "Kayhan Space is on a mission to bring next-generation automation to satellite operations and spaceflight safety. We are a leader in delivering autonomous safety of flight alerts, notifications, and decision plans directly to satellite operators."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    isLink: true,
                                                    text: "Explore products",
                                                    href: "/products/",
                                                    renderIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Hero_module_default())["animation-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Hero_module_default())["shield-container"],
                                style: {
                                    width: width
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Hero_module_default())["interaction-shield"],
                                        onMouseEnter: function() {
                                            return !hasHovered ? handleMouseEnter() : undefined;
                                        },
                                        style: {
                                            width: width,
                                            height: width,
                                            display: !hasHovered ? "block" : "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            className: (Hero_module_default())["scroll-interaction-icon"],
                                            role: "img",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            xmlnsXlink: "http://www.w3.org/1999/xlink",
                                            viewBox: "0 0 48 38",
                                            shapeRendering: "geometricPrecision",
                                            textRendering: "geometricPrecision",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                    className: (Hero_module_default())["touch-icon-container"],
                                                    transform: "translate(7.748154,30.000004)",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        className: "touchIcon",
                                                        d: "M9,26h1c0-.9283-.36875-1.8185-1.02513-2.4749s-1.54661-1.0251-2.47487-1.0251-1.8185.3687-2.47487,1.0251-1.02513,1.5466-1.02513,2.4749h1c0-.663.26339-1.2989.73223-1.7678C5.20107,23.7634,5.83696,23.5,6.5,23.5s1.29893.2634,1.76777.7322C8.73661,24.7011,9,25.337,9,26Zm2.765,3.7c.2232-.1301.4767-.1991.735-.2.3978,0,.7794.158,1.0607.4393s.4393.6629.4393,1.0607v3c0,.9283-.3687,1.8185-1.0251,2.4749s-1.5466,1.0251-2.4749,1.0251h-2.49999c-.76.0015-1.4937-.2781-2.06-.785l-4-3.65c-.21123-.2095-.3554-.4771-.41416-.7687-.05875-.2917-.02946-.5942.08417-.8692s.30645-.5099.55396-.675.53852-.2528.83603-.2521c.31869-.0022.6294.0996.885.29l1.115.76v-5.55c0-.3978.15804-.7794.43934-1.0607s.66284-.4393,1.06066-.4393.77936.158,1.06066.4393.43934.6629.43934,1.0607v2.59c.31983-.1128.66846-.1139.989-.0032s.59409.327.776.6132c.22317-.1301.47669-.1991.73499-.2.2528.0007.5013.0652.7224.1875s.4078.2987.5426.5125Zm.5028,6.0678C12.7366,35.2989,13,34.663,13,34v-3c0-.1326-.0527-.2598-.1464-.3536-.0938-.0937-.221-.1464-.3536-.1464s-.2598.0527-.3535.1464C12.0527,30.7402,12,30.8674,12,31v.5h-1v-1c0-.1326-.0527-.2598-.1464-.3536C10.7598,30.0527,10.6326,30,10.5,30s-.2598.0527-.3535.1464c-.0938.0938-.1465.221-.1465.3536v1h-.99999v-1.5c0-.1326-.05268-.2598-.14645-.3536-.09376-.0937-.22094-.1464-.35355-.1464s-.25979.0527-.35355.1464c-.09377.0938-.14645.221-.14645.3536v1.5h-1v-5.5c0-.1326-.05268-.2598-.14645-.3536-.09376-.0937-.22094-.1464-.35355-.1464s-.25979.0527-.35355.1464c-.09377.0938-.14645.221-.14645.3536v7.45l-2.7-1.85c-.07428-.0557-.16262-.0896-.2551-.098-.09248-.0083-.18545.0093-.26851.0508s-.1529.1053-.20172.1843-.07467.17-.07467.2629c.00055.1312.05263.2569.145.35L6.62001,36c.38419.3284.8746.5061,1.38.5h2.49999c.6631,0,1.2989-.2634,1.7678-.7322Z",
                                                        transform: "translate(-7.748154,-30.000004)",
                                                        clipRule: "evenodd",
                                                        fillRule: "evenodd"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                    className: (Hero_module_default())["mouse-icon-container"],
                                                    transform: "translate(8.5,8)",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        className: "mouseIcon",
                                                        transform: "translate(-8.5,-8)",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: (Hero_module_default())["mouse-icon-click"],
                                                                d: "M4,5C4,2.79086,5.79086,1,8,1v0v8h-4v-4Z"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M4,5C4,2.79086,5.79086,1,8,1v2h-1v1v2v1h1v2h1v-2h1v-1-2-1h-1v-2c2.2091,0,4,1.79086,4,4v6c0,2.2091-1.7909,4-4,4h-1c-2.20914,0-4-1.7909-4-4v-6ZM3,5C3,2.23858,5.23858,0,8,0h1c2.7614,0,5,2.23858,5,5v6c0,2.7614-2.2386,5-5,5h-1c-2.76142,0-5-2.2386-5-5v-6ZM8,4h1v2h-1v-2Z",
                                                                clipRule: "evenodd",
                                                                fillRule: "evenodd"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Hero_module_default())["scroll-shield"], " ").concat((Hero_module_default())["scroll-shield-top"]),
                                        style: {
                                            height: shieldBufferTopBottom,
                                            width: width,
                                            top: -width
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Hero_module_default())["scroll-shield"], " ").concat((Hero_module_default())["scroll-shield-right"]),
                                        style: {
                                            height: shieldBufferLeftRight,
                                            width: shieldBufferTopBottom,
                                            top: -(shieldBufferLeftRight + shieldBufferTopBottom)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Hero_module_default())["scroll-shield"], " ").concat((Hero_module_default())["scroll-shield-bottom"]),
                                        style: {
                                            height: shieldBufferTopBottom,
                                            width: width
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Hero_module_default())["scroll-shield"], " ").concat((Hero_module_default())["scroll-shield-left"]),
                                        style: {
                                            height: shieldBufferLeftRight,
                                            width: shieldBufferTopBottom,
                                            top: -(shieldBufferLeftRight + shieldBufferTopBottom)
                                        }
                                    })
                                ]
                            }),
                            show3d ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_GlobeAnimationWrapper, {
                                height: width,
                                width: width
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
});
/* harmony default export */ var Hero = (HomeHero);

// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
;// CONCATENATED MODULE: ./Components/assets/logo--twitter.svg
var _path;
function logo_twitter_extends() { logo_twitter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_twitter_extends.apply(this, arguments); }

var SvgLogoTwitter = function SvgLogoTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", logo_twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.92 24.94A12.76 12.76 0 0 0 24.76 12.1v-.59A9.4 9.4 0 0 0 27 9.18a9.31 9.31 0 0 1-2.59.71 4.56 4.56 0 0 0 2-2.5 8.89 8.89 0 0 1-2.86 1.1 4.52 4.52 0 0 0-7.7 4.11 12.79 12.79 0 0 1-9.3-4.71 4.51 4.51 0 0 0 1.4 6 4.47 4.47 0 0 1-2-.56v.05a4.53 4.53 0 0 0 3.55 4.45 4.53 4.53 0 0 1-2 .08A4.51 4.51 0 0 0 11.68 21a9.05 9.05 0 0 1-5.61 2A9.77 9.77 0 0 1 5 22.91a12.77 12.77 0 0 0 6.92 2"
  })), /*#__PURE__*/react.createElement("path", {
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }));
};
/* harmony default export */ var logo_twitter = (SvgLogoTwitter);
;// CONCATENATED MODULE: ./Components/assets/logo--linkedin.svg
var logo_linkedin_path;
function logo_linkedin_extends() { logo_linkedin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_linkedin_extends.apply(this, arguments); }

var SvgLogoLinkedin = function SvgLogoLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", logo_linkedin_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), logo_linkedin_path || (logo_linkedin_path = /*#__PURE__*/react.createElement("path", {
    d: "M26.2 4H5.8C4.8 4 4 4.8 4 5.7v20.5c0 .9.8 1.7 1.8 1.7h20.4c1 0 1.8-.8 1.8-1.7V5.7c0-.9-.8-1.7-1.8-1.7zM11.1 24.4H7.6V13h3.5v11.4zm-1.7-13c-1.1 0-2.1-.9-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.1 0 2.1.9 2.1 2.1s-1 2.1-2.1 2.1zm15.1 12.9H21v-5.6c0-1.3 0-3.1-1.9-3.1S17 17.1 17 18.5v5.7h-3.5V13h3.3v1.5h.1c.5-.9 1.7-1.9 3.4-1.9 3.6 0 4.3 2.4 4.3 5.5v6.2z"
  })), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }));
};
/* harmony default export */ var logo_linkedin = (SvgLogoLinkedin);
;// CONCATENATED MODULE: ./Components/assets/logo--www.svg
var logo_www_path;
function logo_www_extends() { logo_www_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_www_extends.apply(this, arguments); }

var SvgLogoWww = function SvgLogoWww(props) {
  return /*#__PURE__*/react.createElement("svg", logo_www_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), logo_www_path || (logo_www_path = /*#__PURE__*/react.createElement("path", {
    d: "M30 11h-5v10h2v-3h3a2.003 2.003 0 0 0 2-2v-3a2.002 2.002 0 0 0-2-2Zm-3 5v-3h3l.001 3ZM10 13h2v8h2v-8h2v-2h-6v2zM23 11h-6v2h2v8h2v-8h2v-2zM6 11v4H3v-4H1v10h2v-4h3v4h2V11H6z"
  })), /*#__PURE__*/react.createElement("path", {
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }));
};
/* harmony default export */ var logo_www = (SvgLogoWww);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Intro.tsx









var HomeIntro = /*#__PURE__*/ react.forwardRef(function HomeIntro(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "intro",
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content-container padded-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "_2-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col empty"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h3",
                                    children: props.data && props.data.IntroParagraph ? props.data.IntroParagraph : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "normalize-text span",
                                                children: "Kayhan Space brings next generation autonomy to satellite operations"
                                            }),
                                            " and ensures spaceflight safety. Our automation removes delays and errors from the critical path of response to high-risk events."
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                    autoPlay: true,
                    infiniteLoop: true,
                    showThumbs: false,
                    showArrows: false,
                    showStatus: false,
                    children: props.data && props.data.Carousel && props.data.Carousel.length ? props.data.Carousel.map(function(c, i) {
                        if (c) {
                            var imgSrc = c.Photo ? c.Photo.data ? (0,media/* getStrapiMedia */.$)(c.Photo) : "" : "";
                            if (imgSrc && c.Link) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "carousel-item",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "carousel-image",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: imgSrc,
                                                layout: "responsive",
                                                height: c.Photo.data.attributes.height ? c.Photo.data.attributes.height : 578,
                                                width: c.Photo.data.attributes.width ? c.Photo.data.attributes.width : 1098,
                                                alt: c.Photo.data.attributes.caption ? c.Photo.data.attributes.caption : "Caption is not available for this photo."
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "legend",
                                            href: c.Link,
                                            target: "_blank",
                                            rel: "nofollow noopener noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "legend-content",
                                                    children: c.Description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "h6",
                                                                children: c.Type ? c.Type : "General"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: c.Description
                                                            })
                                                        ]
                                                    }) : null
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pseudo-icon-button",
                                                    children: c.Link.includes("twitter.com") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_twitter, {}) : c.Link.includes("linkedin.com") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_linkedin, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_www, {})
                                                })
                                            ]
                                        })
                                    ]
                                }, "home-carousel-".concat(i));
                            }
                        }
                        return null;
                    }) : null
                })
            ]
        })
    });
});
/* harmony default export */ var Intro = (HomeIntro);

// EXTERNAL MODULE: ./PageSections/HomeSections/Subscribe.module.scss
var Subscribe_module = __webpack_require__(2697);
var Subscribe_module_default = /*#__PURE__*/__webpack_require__.n(Subscribe_module);
// EXTERNAL MODULE: ./Components/Input.tsx
var Input = __webpack_require__(6578);
// EXTERNAL MODULE: ./Components/assets/email.svg
var assets_email = __webpack_require__(4593);
// EXTERNAL MODULE: ./Utils/StringUtil.ts
var StringUtil = __webpack_require__(831);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Subscribe.tsx













var HomeSubscribe = /*#__PURE__*/ react.forwardRef(function HomeSubscribe(props, ref) {
    var handleOnChange = function handleOnChange(e) {
        var input = e.target;
        setEmailValidated((0,StringUtil/* validateEmail */.oH)(input.value));
        setEmail(input.value);
    };
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), email = _$ref[0], setEmail = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), emailValidated = _$ref1[0], setEmailValidated = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Splitter/* default */.Z, {
                    isThick: true,
                    vizTrigger: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container padded-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "_2-col-titled",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "h2 brand-emphasize",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typer/* default */.Z, {
                                    vizTrigger: true,
                                    text: "Subscribe"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "_2-col mobile-no-padding-bottom",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "big-text",
                                                        children: props.SubscribeParagraph ? props.SubscribeParagraph : "Stay tuned with latest news, events, and solutions from Kayhan Space via email."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                        id: "home-subscribe-form",
                                                        name: "home-subscribe-form",
                                                        className: (Subscribe_module_default())["subscribe-form"],
                                                        action: props.SubscribeEndpoint ? props.SubscribeEndpoint : "https://formspree.io/f/xvolbbaq",
                                                        method: "POST",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                autoComplete: "email",
                                                                name: "email",
                                                                label: "Email",
                                                                onChange: handleOnChange,
                                                                value: email,
                                                                placeholder: "Type your email here."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                                title: "Subscribe text filler",
                                                                placeholder: "Subscribe",
                                                                className: (Subscribe_module_default())["subscribe-text"],
                                                                name: "message",
                                                                defaultValue: "Subscribe"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                renderIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_email/* default */.Z, {}),
                                                                isSubmit: true,
                                                                text: "Subscribe",
                                                                disabled: !emailValidated
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((Subscribe_module_default())["buttons-wrapper"]),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Subscribe_module_default())["buttons-container"],
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    label: "Open a link to Kayhan Space's Twitter Account",
                                                                    renderIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_twitter, {}),
                                                                    classNames: (Subscribe_module_default())["subscribe-button"],
                                                                    type: "secondary",
                                                                    isLinkWrapper: true,
                                                                    isLink: true,
                                                                    openNewTab: true,
                                                                    href: props.TwitterURL ? props.TwitterURL : "https://twitter.com/kayhanspace",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            "Twitter",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            "@kayhanspace"
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    label: "Open a link to Kayhan Space's LinkedIn Account",
                                                                    renderIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_linkedin, {}),
                                                                    classNames: (Subscribe_module_default())["subscribe-button"],
                                                                    type: "secondary",
                                                                    isLinkWrapper: true,
                                                                    isLink: true,
                                                                    openNewTab: true,
                                                                    href: props.LinkedInURL ? props.LinkedInURL : "https://www.linkedin.com/company/kayhan-space/",
                                                                    text: "LinkedIn"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
});
/* harmony default export */ var Subscribe = (HomeSubscribe);

// EXTERNAL MODULE: ./Modals/SubscribeSuccess.module.scss
var SubscribeSuccess_module = __webpack_require__(9131);
var SubscribeSuccess_module_default = /*#__PURE__*/__webpack_require__.n(SubscribeSuccess_module);
// EXTERNAL MODULE: ./Components/assets/exit.svg
var exit = __webpack_require__(562);
// EXTERNAL MODULE: ./Components/FancyImage.tsx
var FancyImage = __webpack_require__(7591);
;// CONCATENATED MODULE: ./assets/maral.png
/* harmony default export */ var maral = ({"src":"/_next/static/media/maral.db080111.png","height":460,"width":460,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEVMaXGbmKKCfIq8vL1fW2euqLl2dndSUlmioaSCgoKHgY9gXWMFBQampqbDwcSdmKrR0NBLSU1kZGRrZXWNjY2qqqonJyempqbX2NZ/fIU1NDbXy+p2cX1eWmP1YJV1AAAAGHRSTlMAtHT+i/BXB6dB8HX9leqL+fsh7vQz+trAwbVgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVR4nB3KRxKAIADAwNCLKHYB9f/fdPCS2UMAJ/frAMdQzyZ+tJS2FdDP8kZLyLHOxQRGMxWlbH/k7bUD8KL3A2IgAmLLiT7yAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./Modals/SubscribeSuccess.tsx







var SubscribeSuccessModal = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SubscribeSuccess_module_default())["subscribe-thanks-container"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SubscribeSuccess_module_default())["subscribe-thanks-content"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SubscribeSuccess_module_default())["thanks-message"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FancyImage/* default */.Z, {
                            classNames: "".concat((SubscribeSuccess_module_default())["maral-floating"], " dark-loader"),
                            src: maral,
                            alt: "Kayhan Space's mascot, Maral!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "You're subscribed!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "We look forward to keeping you updated."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    classNames: (SubscribeSuccess_module_default())["subscribe-dismiss"],
                    text: "Dismiss",
                    isLink: true,
                    href: "/#",
                    renderIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(exit/* default */.Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ var SubscribeSuccess = (SubscribeSuccessModal);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./Components/Link.tsx + 1 modules
var Link = __webpack_require__(969);
// EXTERNAL MODULE: ./Components/NewsBanner.module.scss
var NewsBanner_module = __webpack_require__(5374);
var NewsBanner_module_default = /*#__PURE__*/__webpack_require__.n(NewsBanner_module);
;// CONCATENATED MODULE: ./Components/NewsBanner.tsx





var NewsBanner = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((NewsBanner_module_default())["news-banner-container"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: "".concat(props.LinkDestination),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-container",
                children: "".concat(props.LinkTitle)
            })
        })
    });
};
/* harmony default export */ var Components_NewsBanner = (NewsBanner);

;// CONCATENATED MODULE: ./pages/index.tsx
















var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
var DynamicGame = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8583).then(__webpack_require__.bind(__webpack_require__, 8583));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8583)
            ];
        }
    },
    ssr: false
});
var Home = function(param) {
    var pageContent = param.pageContent;
    var ref, ref1;
    var initialPagesArr = react.useRef(pageContent ? [
        {
            Component: Intro,
            data: {
                Carousel: pageContent.Carousel,
                IntroParagraph: pageContent.IntroParagraph
            },
            title: "Intro",
            anchorId: "intro"
        },
        {
            Component: Products,
            data: pageContent.ProductsList,
            title: "Products",
            anchorId: "products"
        },
        {
            Component: Quotes,
            data: pageContent.Quotes,
            title: "Quotes",
            anchorId: "quotes"
        },
        {
            Component: Performance,
            data: {
                MetricsParagraph1: pageContent.MetricsParagraph1,
                MetricsParagraph2: pageContent.MetricsParagraph2,
                PerformanceCTATitle: pageContent.PerformanceCTATitle,
                PerformanceCTAUrl: pageContent.PerformanceCTAUrl
            },
            title: "Metrics",
            anchorId: "performance"
        }
    ] : []);
    var heroRef = /*#__PURE__*/ react.createRef();
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showSubscribeModal = ref2[0], setShowSubscribeModal = ref2[1];
    var elRefs = react.useRef(initialPagesArr.current.map(function() {
        return /*#__PURE__*/ react.createRef();
    }));
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), activeNo = ref3[0], setActiveNo = ref3[1];
    var pageSections = react.useRef(initialPagesArr.current.map(function(param, i) {
        var Component = param.Component, title = param.title, anchorId = param.anchorId, data = param.data;
        var newElement = {
            jsx: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                data: data,
                sectionNo: i,
                ref: elRefs.current[i]
            }, "section-".concat(i)),
            title: title,
            anchorId: anchorId
        };
        return newElement;
    }));
    var asPath = (0,router.useRouter)().asPath;
    react.useEffect(function() {
        var hash = asPath.split("#")[1];
        setShowSubscribeModal(hash === "subscribeSuccess");
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            pageContent && pageContent.Metadata ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    pageContent.Metadata.Title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: pageContent.Metadata.Title
                    }, "title") : null,
                    pageContent.Metadata.Title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: pageContent.Metadata.Title
                    }, "twname") : null,
                    pageContent.Metadata.Title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: pageContent.Metadata.Title
                    }, "ogtitle") : null,
                    pageContent.Metadata.Description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: pageContent.Metadata.Description
                    }, "desc") : null,
                    pageContent.Metadata.Description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: pageContent.Metadata.Description
                    }, "ogdesc") : null,
                    pageContent.Metadata.Description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: pageContent.Metadata.Description
                    }, "twdesc") : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: publicRuntimeConfig.NEXT_PUBLIC_SITE_URL
                    }, "canonical")
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "404 Page - Kayhan Space"
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "404 Page - Kayhan Space"
                    }, "twname"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "404 Page - Kayhan Space"
                    }, "ogtitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Even our astrodynamicists cannot find the page you are looking for."
                    }, "desc"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: "Even our astrodynamicists cannot find the page you are looking for."
                    }, "ogdesc"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Even our astrodynamicists cannot find the page you are looking for."
                    }, "twdesc"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat(publicRuntimeConfig.NEXT_PUBLIC_SITE_URL, "/error")
                    }, "canonical")
                ]
            }),
            pageContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showSubscribeModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeSuccess, {}) : null,
                    ((ref = pageContent.NewsBanner) === null || ref === void 0 ? void 0 : ref.LinkTitle) && ((ref1 = pageContent.NewsBanner) === null || ref1 === void 0 ? void 0 : ref1.LinkDestination) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_NewsBanner, {
                        LinkDestination: pageContent.NewsBanner.LinkDestination,
                        LinkTitle: pageContent.NewsBanner.LinkTitle
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                                HeroParagraph: pageContent.HeroParagraph,
                                ref: heroRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content-wrapper",
                                children: [
                                    pageSections.current.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNav/* default */.Z, {
                                        pageSections: pageSections.current,
                                        elRefs: elRefs.current,
                                        activationRef: heroRef,
                                        setActiveNo: setActiveNo,
                                        activeNo: activeNo
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sections-container",
                                        children: [
                                            pageSections.current.map(function(sectionEl, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: sectionEl.jsx
                                                }, "section-".concat(idx));
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscribe, {
                                                TwitterURL: pageContent.TwitterURL,
                                                LinkedInURL: pageContent.LinkedInURL,
                                                SubscribeEndpoint: pageContent.SubscribeEndpoint,
                                                SubscribeParagraph: pageContent.SubscribeParagraph
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "".concat(pageContent.PageType, "-").concat(pageContent.slug))
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicGame, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 2145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getStrapiMedia; }
/* harmony export */ });
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7018);

function getStrapiMedia(media) {
    if (media && media.data) {
        var url = media.data.attributes.url;
        var imageUrl = url.startsWith("/") ? (0,_api__WEBPACK_IMPORTED_MODULE_0__/* .getStrapiURL */ .p)(url) : url;
        return imageUrl;
    }
    return "#invalidLink";
}


/***/ }),

/***/ 7045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fade-in-container":"FadeIn_fade-in-container__83fzw","fade-in-content":"FadeIn_fade-in-content__tKAHh","no-top":"FadeIn_no-top__Eiwn1","active":"FadeIn_active__h02ZD"};

/***/ }),

/***/ 2110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-input":"Input_text-input__40r_J"};

/***/ }),

/***/ 5374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"news-banner-container":"NewsBanner_news-banner-container__0dSWg"};

/***/ }),

/***/ 9131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dark":"SubscribeSuccess_dark__s89IQ","light":"SubscribeSuccess_light__JqoYd","subscribe-thanks-container":"SubscribeSuccess_subscribe-thanks-container__EKEfQ","subscribe-thanks-content":"SubscribeSuccess_subscribe-thanks-content__3jRCx","thanks-message":"SubscribeSuccess_thanks-message__SO88h","maral-floating":"SubscribeSuccess_maral-floating__mlxEs","maralFloat":"SubscribeSuccess_maralFloat__TNuMw","subscribe-dismiss":"SubscribeSuccess_subscribe-dismiss__u1yuS"};

/***/ }),

/***/ 6492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hero-text-background":"Hero_hero-text-background__ICWnW","scroll-shield":"Hero_scroll-shield__KL45l","scroll-shield-bottom":"Hero_scroll-shield-bottom__2HmIc","scroll-shield-top":"Hero_scroll-shield-top__ptYRb","scroll-shield-right":"Hero_scroll-shield-right__cPmdy","scroll-shield-left":"Hero_scroll-shield-left__y5p4c","shield-container":"Hero_shield-container__HWzjv","interaction-shield":"Hero_interaction-shield__qJfj3","hero-content-container":"Hero_hero-content-container__nea4N","animation-container":"Hero_animation-container__92nYN","scene-container":"Hero_scene-container__2v_R4","scroll-interaction-icon":"Hero_scroll-interaction-icon__Vw8xA","mouse-icon-container":"Hero_mouse-icon-container___mn5N","mouseIconAnimation":"Hero_mouseIconAnimation__R_Ebk","mouse-icon-click":"Hero_mouse-icon-click__P9sOB","touch-icon-container":"Hero_touch-icon-container__hfgTN","touchIconAnimation":"Hero_touchIconAnimation__AQ41s","hero-cta-button":"Hero_hero-cta-button__CRy9Z","home-hero":"Hero_home-hero__gc8F3"};

/***/ }),

/***/ 5267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dark":"Performance_dark__unWff","light":"Performance_light__ulw5f","performance-container":"Performance_performance-container__NujDF","active":"Performance_active__31ZPs","metric-number":"Performance_metric-number__epiC0","metrics-column":"Performance_metrics-column__yTKLL","metric-bubble-container":"Performance_metric-bubble-container__2UR2c","metric-container":"Performance_metric-container__TWsbA"};

/***/ }),

/***/ 1123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"solutions-list":"Products_solutions-list__PqIDr","stories-list":"Products_stories-list__kWOnT","solutions-list-3col":"Products_solutions-list-3col__Ii9Ur","story-content":"Products_story-content__rjhvN","description":"Products_description__POw0T","icon-button":"Products_icon-button__N4KWQ","video-container":"Products_video-container__Tt4x2","video-thumbnail":"Products_video-thumbnail__fV9Uf","active":"Products_active____2EF","case-studies-section":"Products_case-studies-section__o5wP3"};

/***/ }),

/***/ 1206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quote-ornament":"Quotes_quote-ornament__YtIDW","quote-cursor":"Quotes_quote-cursor__nZaQ1","blink":"Quotes_blink__IP0Zd","active":"Quotes_active__RWBx6","ghosts":"Quotes_ghosts__Vp3xT","ghost":"Quotes_ghost__ThZS1","quote-container":"Quotes_quote-container__osWG4","quote-content":"Quotes_quote-content___wf1y","quote":"Quotes_quote__GlJOH","content-ghost-container":"Quotes_content-ghost-container__Lk8P2","name-container":"Quotes_name-container__kB0u9","quote-name-title":"Quotes_quote-name-title__BlObz","quote-block":"Quotes_quote-block__I60n8","quote-name":"Quotes_quote-name__hlk_r","quote-title":"Quotes_quote-title__I51eT","q-container":"Quotes_q-container__Nw_T9","deleting":"Quotes_deleting__K_zKZ"};

/***/ }),

/***/ 2697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscribe-text":"Subscribe_subscribe-text__1G6XP","buttons-wrapper":"Subscribe_buttons-wrapper__pd7Ve","buttons-container":"Subscribe_buttons-container__YTkmZ","subscribe-button":"Subscribe_subscribe-button__kadvQ","subscribe-form":"Subscribe_subscribe-form__G9Mfs"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4077,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);